jQuery.feature_import("js-datepicker",
  () => require("./datepicker.js"),
  mod => mod.feature_js_datepicker
);